import { createGlobalStyle } from "styled-components/macro";

import { colors } from "./Styles.variables";

// Based on from Bootstrap
const getScrollBarWidth = () => {
  const scrollDiv = document.createElement("div");
  scrollDiv.style.height = "50px";
  scrollDiv.style.overflow = "scroll";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  scrollDiv.style.width = "50px";
  document.body.appendChild(scrollDiv);
  const scrollbarWidth =
    scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

const StylesDesktop = createGlobalStyle`
  body {
    background-color: ${colors.gray200};
    color: ${colors.gray800};

    &.no-scroll {
      padding-right: ${getScrollBarWidth()}px;
    }
  }  
`;

export default StylesDesktop;
